import * as z from './base';
export class ZodAny extends z.ZodType {
    constructor() {
        super(...arguments);
        // opt optional: () => ZodUnion<[this, ZodUndefined]> = () => ZodUnion.create([this, ZodUndefined.create()]);
        // null nullable: () => ZodUnion<[this, ZodNull]> = () => ZodUnion.create([this, ZodNull.create()]);
        this.toJSON = () => this._def;
    }
}
ZodAny.create = () => {
    return new ZodAny({
        t: z.ZodTypes.any,
    });
};
